import { render, staticRenderFns } from "./PopupEditPouringCategory.vue?vue&type=template&id=35daebd2&scoped=true&"
import script from "./PopupEditPouringCategory.vue?vue&type=script&lang=js&"
export * from "./PopupEditPouringCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35daebd2",
  null
  
)

export default component.exports